import React, { Component } from 'react'

import { Container, Row, Col, Image } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {
  render() {
    return (
      <div className={styles.aboutng}>
        <Container>
          <Row>
            <Col lg={6}>
              <div className={styles.aboutng_toptext}>Наша миссия</div>
              <div className='d-flex align-items-end justify-content-between'>
                <div className={styles.aboutng_about_title}>
                  свой подход<br />
                  к каждому клиенту
                </div>
                <div className='d-lg-none'> </div>
              </div>
              <div className={styles.aboutng_text}>
                <p>
                  Наш бренд взял вектор на импортозамещение и активно реализует слоган <b>made-in-Moscow</b>,
                  предлагая покупателям высококачественную одежду, созданную с таким же вниманием к
                  деталям, как и у западных марок, но по более конкурентной цене. 90% продукции <b>BRUNO</b>
                  <b>ALTRO</b> производится в России. Здесь делают ставку на натуральные ткани высочайшего качества,
                  изысканную фурнитуру и безупречный крой, которые делают каждую вещь особенной.
                </p>
                <p>
                  <b>Одежда BRUNO ALTRO</b> – это ода комфорту и стилю. Она идеально подходит для динамичной
                  жизни в большом городе, позволяя чувствовать себя уверенно и элегантно в любой ситуации.
                  Бренд предлагает широкий ассортимент дизайнерской одежды (comfort casual – главное
                  направление) для мужчин и женщин, обувь, головные уборы, а также аксессуары. <b>BRUNO
                  ALTRO</b> не придерживается жестких сезонных рамок, постоянно обновляя свой ассортимент и
                  предлагая клиентам актуальные и стильные новинки. От классических брючных костюмов до
                  легких платьев и уютных кардиганов – в коллекциях <b>BRUNO ALTRO</b> каждый покупатель найдет то,
                  что подчеркнет ее индивидуальность и поможет создать свой неповторимый образ.
                </p>
              </div>
              <div className={styles.aboutng_mobimages + ` d-flex w-100 justify-content-center d-lg-none`}>
                <Image alt="BRUNO ALTRO 1" style={{ height: `auto` }} src="./files/images/aboutng_image_mob_2.png" width="355" height="410" />
              </div>
            </Col>
            <Col lg={6}>
              <div className={styles.aboutng_images + ` d-none d-lg-block`}>
                <Image alt="BRUNO ALTRO 2" className={styles.aboutng_images_4} src="./files/images/aboutng4.png" width={396} height={583} />
                <Image alt="BRUNO ALTRO 3" className={styles.aboutng_images_5} src="./files/images/aboutng5.png" width={322} height={450} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}